// 角色常量
export const ROLE_ADMIN = 'ROLE_ADMIN';

// 才艺学习类型映射
export const LEARN_TYPE = {
  ARTICLE: '读文',
  MUSIC: '音乐',
} as const;
export type LearnType = keyof typeof LEARN_TYPE;

// ACGN 类型映射
export const ACGN_TYPE = {
  A: '动画',
  C: '漫画',
  G: '游戏',
  N: '小说',
} as const;
export type AcgnType = keyof typeof ACGN_TYPE;

// ACGN 状态映射
export const ACGN_STATE = {
  BE: '未看',
  ING: '正在看',
  ED: '看完',
} as const;
export type AcgnState = keyof typeof ACGN_STATE;

// 学习状态映射
export const LEARN_STATE = {
  BE: '未学',
  ING: '学习中',
  ED: '已学',
} as const;
export type LearnState = keyof typeof LEARN_STATE;

// 周表星期标签
export const DAY_LABELS = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'] as const;

// 日期基准常量（用于周数计算）
export const BASE_YEAR = 2026;
export const BASE_MONTH = 0;          // 1月（0-based）
export const BASE_DAY = 5;
export const BASE_UTC = Date.UTC(BASE_YEAR, BASE_MONTH, BASE_DAY) - 8 * 3600 * 1000;

// 标签页中的“全部”常量
export const ALL_TAG = 'ALL';

// 订单状态枚举
export enum OrderStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
  CANCEL_REQUESTED = 'CANCEL_REQUESTED',
  SHIPPED = 'SHIPPED',
  RECEIVED = 'RECEIVED',
}

export const OrderStatusMap: Record<OrderStatus, string> = {
  [OrderStatus.PENDING]: '待审核',
  [OrderStatus.ACCEPTED]: '已接单',
  [OrderStatus.COMPLETED]: '已完成',
  [OrderStatus.REJECTED]: '已拒绝',
  [OrderStatus.CANCELLED]: '已取消',
  [OrderStatus.CANCEL_REQUESTED]: '取消申请中',
  [OrderStatus.SHIPPED]: '已发货',
  [OrderStatus.RECEIVED]: '已收货',
};

export enum TopicStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
}

export const TopicStatusMap: Record<string, string> = {
  [TopicStatus.ACTIVE]: '正在收集',
  [TopicStatus.INACTIVE]: '停止收集',
  [TopicStatus.DELETED]: '已删除',
};